(function(angular){
	'use strict';
	
	angular.module('realEstateVsInflationChartModule', [
		'BaseConfig',
		'highChartsModule'
	]);
	
})(window.angular);